import { render } from "./ActionWebhook.vue?vue&type=template&id=42c674ba"
import script from "./ActionWebhook.vue?vue&type=script&lang=js"
export * from "./ActionWebhook.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__